import { CheckIn, CreateGoalInput } from "../../api/graphql/API"

export interface iAppButton {
  title?: any
  Icon?: object
  className?: string
  iconOnRight?: boolean
  [id: string]: any
  onClick?: () => void
}

export type registrationButtonWrapper_FuncType = (ButtonElement: object) => any

export interface iListingCardView {
  title: string
  image: any
  description: string
  link?: string
}

export interface iAskSectionCard extends iListingCardView {
  image: any
  isUser?: boolean
  buttonTitle?: string
  buttonIcon?: any
}

export interface iNavbarView {
  pageTitle: string
  links: iNavSidebarLink[]
  SignupButton: any
  LoginButton: any
  LogoutButton: any
}

export interface iNavbar {
  pageTitle: string
}

export type toggleSidebar_FuncType = (open: boolean) => void

export interface iSidebarWrapper {
  children?: object
  sidebarOpen: boolean
  onToggleSidebar: toggleSidebar_FuncType
}

export interface iNavSidebarLink {
  title: string
  to?: string
  external: boolean
  Icon?: object
  wrapper?: registrationButtonWrapper_FuncType
  ButtonComponent?: any
  wrapperClassName?: string
  onClick?: () => void
}

export interface iNavSidebar {
  sidebarOpen: boolean
  onToggleSidebar: toggleSidebar_FuncType
  links?: iNavSidebarLink[]
  pageTitle: string
}

export interface iAskSectionView {
  content: iAskSectionCard[]
  isUser: boolean
}

export interface iContentSectionWrapper {
  children?: object
  title: string
  Icon?: object
  showSearchButton?: boolean
}

export interface iExploreSectionView {
  topics: iArticleTopicForPageContext[]
}

export interface iTopicMetaData {
  title: string
  image: any
  description: string
  Icon: any
}

export interface iArticleTopic extends iTopicMetaData {
  slug: string
  slugPrefix?: string
}

export interface iArticleThumbnail {
  childImageSharp: {
    fluid: any
  }
}

export interface iPageExcerpt {
  id: number
  title: string
  slug: string
  link: string
  introduction: string
  thumbnail: {
    childImageSharp: {
      fluid: any
    }
  }
}

export interface iArticleTranslation {
  language: string
  content: string
}

export interface iUsefulLink {
  title: string
  link: string
}

export type iFeaturedMedia = string

export interface iArticleContentData {
  default: string
  translations: iArticleTranslation[]
}

export interface iArticleContent {
  title?: iArticleContentData
  heading?: iArticleContentData
  paragraph?: iArticleContentData
  bullets?: {
    default: string[]
    translations: {
      language: string
      content: string[]
    }[]
  }
}

export interface RelatedVideo {
  link: string
  title: string
}

export interface iArticleData {
  slug: string
  title: string
  source: string
  description: string
  read_time: string
  last_updated_at: string
  related_articles: string[]
  related_videos: RelatedVideo[]
  previous_articles: string[]
  next_articles: string[]
  useful_links: iUsefulLink[]
  content: iArticleContent[]
  thumbnail: iArticleThumbnail
}

export interface iArticleTopicForPageContext {
  slug: string
  title: string
  image: any
  description: string
  slugPrefix: string
  Icon: any
}

export interface IRelatedArticle {
  node: iArticleData
}

export interface iPrevNextArticle {
  node: iArticleData
}

export interface iRelatedArticle {
  node: iArticleData
}

export interface iPageContext {
  data: iArticleData
  topic: iArticleTopicForPageContext
  related_articles: iRelatedArticle[]
  previous_articles: iPrevNextArticle[]
  next_articles: iPrevNextArticle[]
}

export type AskPCOSUserType = {
  __typename: "AskPCOSUser"
  id: string
  user_sub: string
  firstname: string
  lastname: string
  weight?: number | null
  height?: number | null
  country?: string | null
  phone_number?: string | null
  pcos_diagnosed?: boolean | null
  use_smart_goal?: boolean | null
  bookmarked_articles?: Array<string | null> | null
  selected_questions_qpl?: Array<string | null> | null
  read_articles?: Array<string | null> | null
  created_at?: string | null
  last_updated_at?: string | null
  email?: string | null
  weight_history?: Array<number | null> | null
  consent?: boolean | null
  badges?: Array<string | null> | null
  self_assessment?: string | null
  additional_data?: string | null
} | null

export type BmiMetricType = {
  __typename: "AskPCOSUser"
  id: string
  weight: number
  height: number
}

export interface iHabitCard {
  title: string
  Icon: any
}

export interface iAddHabitIconCard {
  IconName: string
  title: string
}

export interface iHabitsDetailsForTabs {
  slug: string
  title: string
  category: string
  Icon: any
  id: string
}

export interface iHabitCategory {
  name: string
  id: string
  defaultIcon: any
}

export interface iGoalProgressBar {
  forNoPeriods: number
  checkIns?: iCheckIn[]
}

export interface iGoal {
  id: string
  forNoPeriods: number
  response: string
  goalId: string
  noTimesInPeriod: number
  obstacle: string
  monthPeriod: string
  yearPeriod: string
  solutions?: string
  selectedSolution: string
  startDate: string
  user_sub: string
  title: string
  checkIns?: iCheckInDict
  completed_goal: Boolean
}

export interface iCheckIn {
  id: string
  goalId: string
  dateTime: string
  user_sub: string
  goalCompleted: boolean
  feelingScale?: number | null | undefined
}

export interface iCheckInDict {
  [dateStr: string]: iCheckIn
}

export enum CheckInCompletion {
  Completed,
  NotCompleted,
  Available,
  NotAvailable,
}

export type iCheckInUnit = { [dateStr: string]: CheckInCompletion }

export type iCheckInValues = {
  [id: string]: iCheckInUnit
}
